/* eslint-disable spire/fenced-imports */
import StripeInitialise from "@affinity/Handlers/StripeInitialise";
import { CustomState } from "@affinity/Store/Reducers";
import ServiceBase from "@affinity/Store/ServiceBase";
import StripePaymentElement from "@affinity/Widgets/CheckoutReviewAndSubmit/StripePaymentElement";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import resetCurrentCartId from "@insite/client-framework/Store/Data/Carts/Handlers/ResetCurrentCartId";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import placeOrder from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";


const mapStateToProps = (state: CustomState) => {
    const location = getLocation(state);
    const isInitialising = state.affinity_stripe_payment.isInitialising;
    const isInitialised = state.affinity_stripe_payment.isInitialised;
    const stripeKey = state.affinity_stripe_payment.stripeKey;
    const completeLink = getPageLinkByPageType(state, "OrderConfirmationPage");
    const failureLink = getPageLinkByPageType(state, "UnhandledErrorPage");

    return {
        location,
        isInitialising,
        isInitialised,
        stripeKey,
        completeLink,
        failureLink,
    };
};

const mapDispatchToProps = {
    StripeInitialise,
}

interface OwnProps extends WidgetProps {
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const StripePayment: React.FC<Props> = ({
    location,
    isInitialising,
    isInitialised,
    stripeKey,
    completeLink,
    failureLink,
    StripeInitialise,
}) => {

    if (!isInitialised && !isInitialising && completeLink && failureLink && location) // Tie to most properties to avoid excessive refires
    {
        StripeInitialise({});
    }

    const parsedQuery = parseQueryString<{ session_id?: string }>(location.search);
    const stripeSessionId = parsedQuery.session_id;
    const completeUrl = `${completeLink?.url ?? ''}?cartId=`;
    const failureUrl = failureLink?.url ?? '';

    return (
        <>
            {isInitialised && stripeKey && (
                <StripePaymentElement stripeKey={stripeKey} stripeSessionId={stripeSessionId} completeUrl={completeUrl} failureUrl={failureUrl} />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StripePayment),
    definition: {
        group: "Checkout - Review & Submit",
        icon: "distribute-spacing-vertical",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
        displayName: "Stripe Payment",
    },
};

export default widgetModule;